import { NavLink, Outlet } from "react-router-dom";

const tabs = [
  { label: "Organisation", to: "/settings/organisation", enabled: true },
  { label: "AI Keys", to: "/settings/ai-keys", enabled: true },
  { label: "API Keys", to: "/settings/api-keys", enabled: true },
  { label: "API Docs", to: "/settings/api-docs", enabled: true },
  { label: "Extraction", to: "/settings/extraction", enabled: true },
  { label: "Teams", to: "/settings/teams", enabled: true },
];

export function SettingsLayout() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="font-serif text-3xl font-normal tracking-[-0.005em] text-[var(--text)]">
          Settings
        </h1>
      </div>

      {/* Tab bar */}
      <div className="border-b border-subtle mb-8">
        <nav className="flex gap-6 -mb-px">
          {tabs.map((tab) =>
            tab.enabled ? (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) =>
                  `pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
                    isActive
                      ? "border-accent text-accent"
                      : "border-transparent text-text-faint hover:text-text-muted hover:border-subtle"
                  }`
                }
              >
                {tab.label}
              </NavLink>
            ) : (
              <span
                key={tab.to}
                className="pb-3 px-1 text-sm font-medium border-b-2 border-transparent text-text-faint cursor-not-allowed"
              >
                {tab.label}
              </span>
            ),
          )}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
